import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape, FormattedHTMLMessage } from 'react-intl';
import { connect } from 'react-redux';
import { tooltipShow, tooltipHide } from '../../helpers/tooltips';
import Statistics from '../../containers/Statistics';
import Status from '../../components/Status';
import { getCampaign } from './actions';
// translate
import messages from './messages';

class DashboardPage extends Component {
  componentWillMount() {
    const { link } = this.props;
    if (link === null) {
      this.fetchData();
    }
  }

  fetchData() {
    const { dispatch } = this.props;
    dispatch(getCampaign());
  }

  render() {
    const { intl, user, link, campaign } = this.props;
    const totalOrderSum = user.member_id ? Number(user.order.order_sum) : 0;

    return (
      <div>
        <div className="container-fluid dashboard-wrap">
          <div className="row">
            <div className="container">
              <div className="row">
                <p className="text-header">
                  <FormattedHTMLMessage {...messages.header} />
                </p>

                {!user.member_id &&
                  <ul className="dashboard-list col-md-10 col-md-push-1">
                    <li className="dashboard-item dashboard-item-first col-xs-12">
                      <span
                        className="dashboard-item-title has-tooltip"
                        onMouseEnter={tooltipShow}
                        onMouseLeave={tooltipHide}
                        data-tooltip={intl.formatMessage(
                          messages.referralLinkTooltip,
                        )}
                      >
                        {intl.formatMessage(messages.referralLink)}
                      </span>
                      <span className="dashboard-numner">
                        {link || '…'}
                      </span>
                    </li>
                    <li>
                      <span className="dashboard-item-title">
                        {intl.formatMessage(messages.noData)}
                      </span>
                    </li>
                  </ul>}

                {user.member_id &&
                  <ul className="dashboard-list col-md-10 col-md-push-1">
                    <li className="dashboard-item dashboard-item-first col-xs-12">
                      <span
                        className="dashboard-item-title has-tooltip"
                        onMouseEnter={tooltipShow}
                        onMouseLeave={tooltipHide}
                        data-tooltip={intl.formatMessage(
                          messages.referralLinkTooltip,
                        )}
                      >
                        {intl.formatMessage(messages.referralLink)}
                      </span>
                      <span className="dashboard-numner">
                        {link || '…'}
                      </span>
                    </li>

                    <li className="dashboard-item col-md-4">
                      <span
                        className="dashboard-item-title has-tooltip"
                        onMouseEnter={tooltipShow}
                        onMouseLeave={tooltipHide}
                        data-tooltip={intl.formatMessage(
                          messages.allReferralsTooltip,
                        )}
                      >
                        {intl.formatMessage(messages.allReferrals)}
                      </span>
                      <span className="dashboard-numner">{user.click}</span>
                    </li>

                    <li className="dashboard-item col-md-4">
                      <span
                        className="dashboard-item-title has-tooltip"
                        onMouseEnter={tooltipShow}
                        onMouseLeave={tooltipHide}
                        data-tooltip={intl.formatMessage(
                          messages.earnedThisMonthTooltip,
                        )}
                      >
                        {intl.formatMessage(messages.earnedThisMonth)}
                      </span>
                      <span className="dashboard-numner">
                        $
                        {Number(user.reward['30days']) +
                          Number(user.bonus['30days']) +
                          Number(user.penalty['30days'])}
                      </span>
                    </li>

                    <li className="dashboard-item col-md-4">
                      <span
                        className="dashboard-item-title has-tooltip"
                        onMouseEnter={tooltipShow}
                        onMouseLeave={tooltipHide}
                        data-tooltip={intl.formatMessage(
                          messages.earnedToDateTooltip,
                        )}
                      >
                        {intl.formatMessage(messages.earnedToDate)}
                      </span>
                      <span className="dashboard-numner">
                        $
                        {Number(user.reward.total) +
                          Number(user.bonus.total) +
                          Number(user.penalty.total)}
                      </span>
                    </li>

                    <li className="dashboard-item col-md-4">
                      <span
                        className="dashboard-item-title has-tooltip"
                        onMouseEnter={tooltipShow}
                        onMouseLeave={tooltipHide}
                        data-tooltip={intl.formatMessage(
                          messages.onHoldTooltip,
                        )}
                      >
                        {intl.formatMessage(messages.onHold)}
                      </span>
                      <span className="dashboard-numner">
                        ${Number(user.balance)}
                      </span>
                    </li>

                    <li className="dashboard-item col-md-4">
                      <span
                        className="dashboard-item-title has-tooltip"
                        onMouseEnter={tooltipShow}
                        onMouseLeave={tooltipHide}
                        data-tooltip={intl.formatMessage(
                          messages.alreadyReceivedTooltip,
                        )}
                      >
                        {intl.formatMessage(messages.alreadyReceived)}
                      </span>
                      <span className="dashboard-numner">
                        ${Math.abs(Number(user.withdraw))}
                      </span>
                    </li>

                    <li className="dashboard-item col-md-4">
                      <span
                        className="dashboard-item-title has-tooltip"
                        onMouseEnter={tooltipShow}
                        onMouseLeave={tooltipHide}
                        data-tooltip={intl.formatMessage(
                          messages.upcomingPaymentsTooltip,
                        )}
                      >
                        {intl.formatMessage(messages.upcomingPayments)}
                      </span>
                      <span className="dashboard-numner">
                        ${Math.abs(Number(user.hold))}
                      </span>
                    </li>
                  </ul>}
              </div>
            </div>
          </div>
        </div>
        {user.member_id && <Status balance={totalOrderSum} />}
        {user.member_id && campaign && <Statistics campaign={campaign} />}
      </div>
    );
  }
}

DashboardPage.defaultProps = {
  link: null,
  campaign: null,
};

DashboardPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
  user: PropTypes.object.isRequired,
  link: PropTypes.string,
  campaign: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    user: state.get('auth').user,
    link: state.get('dashboard').link,
    campaign: state.get('dashboard').campaign,
  };
}

export default connect(mapStateToProps)(injectIntl(DashboardPage));



// WEBPACK FOOTER //
// ./src/pages/DashboardPage/index.js